import type { Experiment } from 'types';
import { canUseServerSide } from 'definitions/server-side-access';
import { useAuth } from 'hooks/useAuth';
import { VariantsConfig } from './VariantsConfig';
import { GoalsConfig } from './GoalsConfig';
import { UrlTargeting } from './UrlTargeting';
import { ScheduleConfig } from './ScheduleConfig';
import { ActivityLog } from './ActivityLog';
import { AssignedByServerNote, ServerSideConfig } from './ServerSideConfig';

type ExperimentSettingsScreenProps = { experiment: Experiment };

export const ExperimentSettingsScreen = ({ experiment }: ExperimentSettingsScreenProps) => {
  const { user } = useAuth();
  const isCode = experiment.type === 'Server Side';
  // The Assignment card is server-side, staff-only until it launches (PER-178). A Code
  // experiment is still a Server-side experiment to everyone; only the card goes.
  const showAssignment = isCode && canUseServerSide(user);
  // A Server-side experiment assigned by the customer's server never runs the browser's page rules:
  // who is enrolled is its attribute rules, on the Assignment card.
  const isServerDecided = isCode && experiment.decidedBy === 'server';
  const showTargeting = !isServerDecided;
  // Without the card, a server-decided experiment would lose both the card and the page
  // targeting with nothing saying why, so the user gets one read-only line instead.
  const showAssignedByServer = isServerDecided && !showAssignment;

  return (
    <div className="flex flex-col gap-[14px]">
      <VariantsConfig experiment={experiment} />

      {/* Goals apply to every type: a Server-side experiment's conversions are measured the same way. */}
      <GoalsConfig experimentId={experiment.id} />

      {showAssignment && <ServerSideConfig experiment={experiment} />}

      {showAssignedByServer && <AssignedByServerNote />}

      {/*
        Yeni stil Targeting & Conditions artık tek kart
        UrlTargeting bileşeni içinde URL Cookie Device hepsi var
      */}
      {showTargeting && <UrlTargeting experimentId={experiment.id} />}

      <ScheduleConfig experiment={experiment} />

      <ActivityLog experimentId={experiment.id} />
    </div>
  );
};
